import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_93g59u78gb: FaireBrandEntity = {
  token: "b_93g59u78gb",
  type: "brand",
  name: "My Fair Mahjong",
  avatarUrl:
    "https://cdn.faire.com/fastly/86588e1687f421d4a321eb78bbfb0f3ddbb3f8abdf76bfc83c23cb6fbd3d8d45.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ba52d5c04471f81802d40416eca24b0fe92d1f149abe1d026e56c7c38ba934d4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/86588e1687f421d4a321eb78bbfb0f3ddbb3f8abdf76bfc83c23cb6fbd3d8d45.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ba52d5c04471f81802d40416eca24b0fe92d1f149abe1d026e56c7c38ba934d4.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 106,
  isInsider: true,
  description:
    "We are all about SMILES & TILES 🩷💛🩵 \nWe create colorful, bold and joyful designs for all things Mahjong. Mahjong tile sets large and small and accessories to complement our favorite game! \n\nWe look for every opportunity to spread the JOY in connection to a hobby that is so much more than a game. It's community, support, strategy and for those that take to it, this game becomes a part of self-care, friendship and multi-generational traditions.\n\nWe dove into this business HEART first. We are a family-run business with both of us having long careers in the business world. We started our business in the accessory side of things, mostly to gift to friends in our own regular games and casual trainings. Tile design started at a personal time when honoring a loved one with a project kick-started the rapid design of the first large tile set. It wasn't intended to be Southwest themed... the set and theme just came out and almost formed itself in honor of a beloved grandmother (I think this happens when you lead with the heart!). And from there one thing led to another and here we are. We lean into our joyful endeavor, adding little moments of delight and meaning to everything we do- from our signature wave you see on mats, shufflers and racks to the destination themed tile set designs. \n\nSending you SMILES & TILES🩷💛🩵, \n~MFM",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:57.043Z",
    importedBy: "entity-db-cli",
  },
};
